module.exports = __webpack_public_path__ + "img/browser.9470c01c.png";